import { useEffect } from 'react';
import { useAssistantPanel } from '@/contexts/AssistantContext';
import { hasAiAssistantFeature } from '@/lib/ai-assistant/feature';

/** Whether to show the assistant (panel, toggle). `loaded`: this page's myData
 *  answered. Until it does, the account's last answer stands, so navigating
 *  between pages never hides the open panel for the length of a request. */
export function useAssistantAvailable(
  features: ReadonlyArray<string | null> | null | undefined,
  loaded: boolean,
): boolean {
  const { rememberAccess, rememberedAccess } = useAssistantPanel();
  const enabled = hasAiAssistantFeature(features);
  useEffect(() => {
    if (loaded) rememberAccess(enabled);
  }, [loaded, enabled, rememberAccess]);
  return loaded ? enabled : rememberedAccess();
}
